import { Component, computed, input } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PatientCurveModel } from '@models/patient-curve/patient-curve.store';

import { FormErrorDirective } from '@shared/directives/form-error.directive';
import { listDriverSiteGroupsQuery } from '@shared/services/gql.service';

@Component({
  imports: [NgSelectModule, ReactiveFormsModule, FormErrorDirective],
  selector: 'aux-patient-curves-dropdown',
  styleUrl: './patient-curves-dropdown.component.scss',
  templateUrl: './patient-curves-dropdown.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class PatientCurvesDropdownComponent {
  curves = input.required<(listDriverSiteGroupsQuery | PatientCurveModel)[]>();

  patientOptions = computed(() => {
    let flag = false;

    return this.curves().map((curve) => {
      if (!curve.is_blended && !flag) {
        flag = true;

        return {
          name: curve.name,
          showLine: true,
          value: curve.name,
        };
      }

      return {
        name: curve.name,
        showLine: false,
        value: curve.name,
      };
    });
  });

  controlName = input.required<string>();
  curveControl = input.required<AbstractControl>();
  name = input.required<string>();
  validators = input<string>();

  onBlur() {
    this.curveControl().updateValueAndValidity();
  }
}
